export default "__VITE_ASSET__62559cea__"